import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { Row, Col, Card, CardBody, Button, Badge } from "reactstrap";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

import "./datatables.scss";

//Import actions redux
import { getCarrierTypes, getRacks } from "../../store/actions";

import RackList from "../../components/Lists/RackList";

import { carrier_type, racksFields, rack_status } from "../../constants/racks_fields";

class Racks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      rackList: null,
      totalPages: 0,
    };
  }

  componentDidMount() {
    this.props.getRacks(this.state.user, 100, 1);
    this.props.getCarrierTypes(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetRacks === false &&
      prevProps.loadingGetRacks === true
    ) {
      console.log("racks getted");
      let racks = this.props.racks.elements;
      this.setState({ totalPages: this.props.racks.totalPages });
      if (racks) {
        this.prepareData(racks);
      }
    }
  }

  prepareData(racks) {
    let columns = racksFields;
    let rows = [];
    racks.forEach((rack) => {
      let row = {
        rack_name: "Rack" + rack.rackCode,
        rack: rack.rackCode,
        disponible: (
          <Badge
            color={rack_status[rack.disponible].color}
            className={
              "badge-soft-" +
              rack_status[rack.disponible].color +
              " font-size-11"
            }
            pill
          >
            {rack_status[rack.disponible].name}
          </Badge>
        ),
        // P01021-143: numero crudo + etiqueta legible (el enum no cubre todos los códigos
        // posibles de RCS, p. ej. se ha visto '4' en datos reales sin etiqueta propia).
        carrierType_name: rack.carrierType
          ? `${rack.carrierType} - ${carrier_type[rack.carrierType] || rack.carrierType}`
          : "",
        rackArea: rack.rackArea,
        currentPosition: rack.currentPosition,
      };
      rows.push(row);
    });
    let data = { columns, rows };

    this.setState({ rackList: data });
  }
  refresh(event) {
    event.preventDefault();
    this.setState({ rackList: null });
    this.props.getRacks(this.state.user, 100, 1);
  }

  render() {
    if (!this.state.rackList) {
      return (
        <React.Fragment>
          <div>{this.props.t("Cargando...")}</div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <Col className="col-12">
                <Button
                  onClick={(event) => this.refresh(event)}
                  color="primary"
                  className="btn btn-primary buttonStatus usersButtons"
                >
                  <i size="lg" className="mdi  mdi-refresh"></i>
                </Button>
                <Card>
                  <CardBody>
                    <RackList
                      rackList={this.state.rackList}
                      totalPages={this.state.totalPages}
                      getRacks={this.props.getRacks}
                      carrierTypes={this.props.carrier_types}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { loadingGetRacks, racks } = state.GetRacks;
  const { carrier_types } = state.getCarrierTypes;
  return { loadingGetRacks, racks, carrier_types };
};

export default withRouter(
  connect(mapStateProps, {
    getRacks,
    getCarrierTypes,
  })(withNamespaces()(Racks))
);
